import styled from 'styled-components';
import { Typography } from '@mesa-labs/mesa-ui';

const SubHeader = styled(Typography.BodyMedium) <{ mobileMarginBottom?: string, marginBottom?: string }>`
  color: #525866;
  font-size: 14px;
  letter-spacing: -0.154px;
  line-height: 24px;
  margin-bottom: ${(props) => props.mobileMarginBottom || '0px'};

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    margin-bottom: ${(props) => props.marginBottom || '0px'};
  }
`;

export default SubHeader;
